import type { FormOptions } from '@customTypes/types';

export const helpWithOptions: FormOptions = {
  signUpAndAccountCreation: 'Sign Up and account creation',
  multiFactorAuthentication: 'Multi-Factor Authentication',
  signIn: 'Sign In',
  other: 'Other',
};
